module.exports = __webpack_public_path__ + "media/images/landing_page/2023/tools/tables_ru_mobile-9bc05dabe3279dfebb5b13af64d52248.webp";